import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcExtensionBrokerRequestResult, RpcExtensionBrokerResponseKey } from './rpc-extension-broker-model';

export class RpcExtensionBrokerResponseClient {
    /**
     * Sends a response message from an extension broker call
     *
     * @param rpc the rpc service.
     * @param data the extension object.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<void> the promise object.
     */
    public static extensionBrokerResponse(rpc: Rpc, data: RpcExtensionBrokerRequestResult): Promise<void>;
    public static extensionBrokerResponse(rpc: Rpc, data: RpcExtensionBrokerRequestResult, outbound: RpcOutbound): Promise<void>;
    public static extensionBrokerResponse(rpc: Rpc, data: RpcExtensionBrokerRequestResult, outbound?: RpcOutbound): Promise<void> {
        if (rpc.isShell) {
            if (outbound) {
                return RpcOutboundClient.callOutbound(
                    rpc.rpcManager.rpcChannel,
                    outbound,
                    RpcExtensionBrokerResponseKey.command,
                    RpcExtensionBrokerResponseKey.version,
                    data
                );
            } else {
                return RpcOutboundClient.call(rpc, RpcExtensionBrokerResponseKey.command, RpcExtensionBrokerResponseKey.version, data);
            }
        } else {
            return RpcInboundClient.call(rpc, RpcExtensionBrokerResponseKey.command, RpcExtensionBrokerResponseKey.version, data);
        }
    }
}
